import { transactionConstants } from '../constants';
import {
  StripeCoupon,
  V1Coupon,
} from '../py-generated/datalouder/checkout/types';
import { transactionService } from '../services';
import { generalErrorHandler } from './utils';

const CLEAR_PROMO = { type: transactionConstants.GET_PROMO_CLEAR };

export default {
  add, // remove it, doesn't need to be global
  getPrices,
  getPromo,
  clearPromo: CLEAR_PROMO,
};

function add(amount, note, method, reference, promo) {
  return dispatch => {
    dispatch(request());

    return transactionService.add(amount, note, method, reference, promo).then(
      () => {
        dispatch(success());
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: transactionConstants.ADD_REQUEST };
  }
  function success() {
    return { type: transactionConstants.ADD_SUCCESS };
  }
  function failure(error) {
    return { type: transactionConstants.ADD_FAILURE, error };
  }
}

function getPrices() {
  return dispatch => {
    dispatch(request());

    return transactionService.getPrices().then(
      prices => {
        dispatch(success(prices));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: transactionConstants.GET_PRICE_REQUEST };
  }
  function success(prices) {
    return { type: transactionConstants.GET_PRICE_SUCCESS, prices };
  }
  function failure(error) {
    return { type: transactionConstants.GET_PRICE_FAILURE, error };
  }
}

function getPromo(promo: string, usingSandboxPayment: boolean) {
  return dispatch => {
    if (promo === '') {
      return dispatch(CLEAR_PROMO);
    } else {
      dispatch(request(promo));

      return transactionService.getCoupon(promo, usingSandboxPayment).then(
        promo => {
          dispatch(success(promo.v1_coupon, promo.coupon));
        },
        generalErrorHandler(dispatch, error =>
          dispatch(failure(error.toString()))
        )
      );
    }
  };

  function request(code) {
    return { type: transactionConstants.GET_PROMO_REQUEST, code };
  }
  function success(
    promo: V1Coupon | undefined,
    stripeCoupon: StripeCoupon | undefined
  ) {
    return {
      type: transactionConstants.GET_PROMO_SUCCESS,
      promo,
      stripeCoupon,
    };
  }
  function failure(error) {
    return { type: transactionConstants.GET_PROMO_FAILURE, error };
  }
}
